var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLongCardGold({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: ".5vw",
    height: ".35vw",
    viewBox: "0 0 10 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.50533 4.542L3.50499 4.54166L3.50328 4.54064L3.50533 4.542ZM10 3.47107L9.24635 1.48405L6.50697 0L0.830146 3.01541L0 5.22567L3.34654 7L3.40152 4.59509L0.798047 3.11376L1.02138 3.2315L0.894004 3.15834L1.34886 3.39927L0.934982 3.15834L3.50499 4.54166L9.03872 1.6913L8.15292 2.17589L9.19 1.64808L7.13735 2.73126L3.57431 4.68017L3.3462 6.99966L9.99966 3.47039L10 3.47107ZM3.61597 3.84813L2.1172 3.05114L3.57499 3.50034L8.03818 1.52659L3.61597 3.84813Z",
    fill: "#595959"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLongCardGold);
export default __webpack_public_path__ + "static/media/long_card_gold.257e4ac9dfa797d240af183971a9bc19.svg";
export { ForwardRef as ReactComponent };